export default __webpack_public_path__ + "static/media/Icon.bc21dc8a.svg";